const allowedLanguages = {
  bg: "BG",
  // Bulgarian
  bn: "BD",
  // Bengali (Bangladesh)
  cs: "CZ",
  // Czech
  da: "DK",
  // Danish
  de: "DE",
  // German
  el: "GR",
  // Greek
  en: "US",
  // English
  es: "ES",
  // Spanish (Spain)
  et: "EE",
  // Estonian
  fi: "FI",
  // Finnish
  fr: "FR",
  // French
  hi: "IN",
  // Hindi
  hr: "HR",
  // Croatian
  hu: "HU",
  // Hungarian
  id: "ID",
  // Indonesian
  it: "IT",
  // Italian
  ja: "JP",
  // Japanese
  ko: "KR",
  // Korean
  lt: "LT",
  // Lithuanian
  lv: "LV",
  // Latvian
  mt: "MT",
  // Maltese
  nb: "NO",
  // Norwegian (Bokmål)
  no: "NO",
  // Norwegian (General)
  nl: "NL",
  // Dutch (Netherlands)
  pa: "IN",
  // Punjabi (India)
  pl: "PL",
  // Polish
  pt: "PT",
  // Portuguese (Portugal)
  ro: "RO",
  // Romanian
  ru: "RU",
  // Russian
  sk: "SK",
  // Slovak
  sl: "SI",
  // Slovenian
  sv: "SE",
  // Swedish
  th: "TH",
  // Thai (Thailand)
  tr: "TR",
  // Turkish
  vi: "VN",
  // Vietnamese
  zh: "Hans"
  // Chinese Simplified
};
export {
  allowedLanguages
};
//# sourceMappingURL=allowedLanguages.js.map
